import { render, staticRenderFns } from "./QualifierRegister.vue?vue&type=template&id=5b5f1beb"
import script from "./QualifierRegister.vue?vue&type=script&lang=js"
export * from "./QualifierRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b5f1beb')) {
      api.createRecord('5b5f1beb', component.options)
    } else {
      api.reload('5b5f1beb', component.options)
    }
    module.hot.accept("./QualifierRegister.vue?vue&type=template&id=5b5f1beb", function () {
      api.rerender('5b5f1beb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/course/QualifierRegister.vue"
export default component.exports